// TODO: remove all token authorization from API calls
// (API NEEDS TO BE UPDATED TO SUPPORT GUESTS)
// search for 'LRTokenKey' and remove all token checks from this file

class AppointmentBookingSteps extends HTMLElement {
  constructor() {
    super()

    // Elements
    this.locationTitleEl = this.querySelector('[data-appointment-booking-title-location]')
    this.stepEls = this.querySelectorAll('[data-appointment-booking-step]')
    this.backBtn = this.querySelector('[data-appointment-booking-back]')
    this.continueBtn = this.querySelector('[data-appointment-booking-continue]')
    this.optionExamTypeGlasses = this.querySelector('[data-appointment-booking-step-option="exam-type--glasses"]')
    this.optionExamTypeGlassesAndContacts = this.querySelector('[data-appointment-booking-step-option="exam-type--glasses-and-contacts"]')
    this.optionExamAgeChild = this.querySelector('[data-appointment-booking-step-option="exam-age--child"]')
    this.clinicEditBtn = this.querySelector('[data-appointment-booking-clinic-edit]')
    this.clinicNameEl = this.querySelector('[data-appointment-booking-clinic-name]')
    this.clinicsPopup = this.querySelector('[data-appointment-booking-clinics-popup]')
    this.clinicsPopupOverlay = this.querySelector('[data-appointment-booking-clinics-popup-overlay]')
    this.clinicsPopupClose = this.querySelector('[data-appointment-booking-clinics-popup-close]')
    this.clinicsPopupCountContainer = this.querySelector('[data-appointment-booking-clinics-popup-count-container]')
    this.clinicsPopupCountEl = this.querySelector('[data-appointment-booking-clinics-popup-count]')
    this.clinicsPopupLocationsListEl = this.querySelector('[data-appointment-booking-clinics-popup-locations-list]')
    this.clinicsPopupLocationsSearchInput = this.querySelector('[data-appointment-booking-clinics-popup-locations-search]')
    this.clinicsPopupLocationsSearchButton = this.querySelector('[data-appointment-booking-clinics-popup-locations-search-button]')
    this.optometristEditBtn = this.querySelector('[data-appointment-booking-optometrist-edit]')
    this.optometristNameEl = this.querySelector('[data-appointment-booking-optometrist-name]')
    this.optometristsPopup = this.querySelector('[data-appointment-booking-optometrists-popup]')
    this.optometristsPopupOverlay = this.querySelector('[data-appointment-booking-optometrists-overlay]')
    this.optometristsPopupClose = this.querySelector('[data-appointment-booking-optometrists-close]')
    this.optometristChangeBtn = this.querySelector('[data-appointment-booking-optometrist-change]')
    this.optometristSelectContainer = this.querySelector('[data-appointment-booking-optometrist-select-container]')
    this.datesSwiperContainer = this.querySelector('[data-appointment-booking-dates-swiper-container]')
    this.datesSwiperWrapper = this.querySelector('[data-appointment-booking-dates-swiper-wrapper]')
    this.timesGrid = this.querySelector('[data-appointment-booking-times-grid]')
    this.noSlotsEl = this.querySelector('[data-appointment-booking-no-slots]')
    this.patientFormStepEl = this.querySelector('[data-appointment-booking-step-patient-form]')
    this.patientAdultForm = this.querySelector('[data-appointment-booking-form-adult]')
    this.patientAdultFormNameFirst = this.querySelector('[data-appointment-booking-form-adult-name-first]')
    this.patientAdultFormNameLast = this.querySelector('[data-appointment-booking-form-adult-name-last]')
    this.patientAdultFormEmail = this.querySelector('[data-appointment-booking-form-adult-email]')
    this.patientAdultFormDob = this.querySelector('[data-appointment-booking-form-adult-dob]')
    this.patientAdultFormPhone = this.querySelector('[data-appointment-booking-form-adult-phone]')
    this.patientAdultFormNotes = this.querySelector('[data-appointment-booking-form-adult-notes]')
    this.patientAdultFormSubmit = this.querySelector('[data-appointment-booking-form-adult-submit]')
    this.patientChildForm = this.querySelector('[data-appointment-booking-form-child]')
    this.patientChildFormNameFirst = this.querySelector('[data-appointment-booking-form-child-name-first]')
    this.patientChildFormNameLast = this.querySelector('[data-appointment-booking-form-child-name-last]')
    this.patientChildFormParentNameFirst = this.querySelector('[data-appointment-booking-form-child-parent-name-first]')
    this.patientChildFormParentNameLast = this.querySelector('[data-appointment-booking-form-child-parent-name-last]')
    this.patientChildFormEmail = this.querySelector('[data-appointment-booking-form-child-email]')
    this.patientChildFormDob = this.querySelector('[data-appointment-booking-form-child-dob]')
    this.patientChildFormPhone = this.querySelector('[data-appointment-booking-form-child-phone]')
    this.patientChildFormNotes = this.querySelector('[data-appointment-booking-form-child-notes]')
    this.patientChildFormDobError = this.querySelector('[data-appointment-booking-form-child-dob-error]')
    this.patientAdultFormDobError = this.querySelector('[data-appointment-booking-form-adult-dob-error]')
    this.patientFormPhoneError = this.querySelector('[data-appointment-booking-form-phone-error]')
    this.patientChildFormSubmit = this.querySelector('[data-appointment-booking-form-child-submit]')
    this.insuranceForm = this.querySelector('[data-appointment-booking-form-insurance]')
    this.insuranceFormProviderName = this.querySelector('[data-appointment-booking-form-insurance-provider-name]')
    this.insuranceFormPolicy = this.querySelector('[data-appointment-booking-form-insurance-policy]')
    this.insuranceFormProvincialHealthNumber = this.querySelector('[data-appointment-booking-form-insurance-provincial-health-number]')
    this.isPreferredClinicCheckboxes = this.querySelectorAll('[data-appointment-booking-is-preferred-clinic]')
    this.examInfoContainer = this.querySelector('[data-appointment-booking-exam-info]')
    this.examInfoClinicEl = this.querySelector('[data-appointment-booking-exam-info-clinic]')
    this.examInfoDetailsEl = this.querySelector('[data-appointment-booking-exam-info-details]')
    this.examInfoTimeEl = this.querySelector('[data-appointment-booking-exam-info-time]')
    this.examInfoChangeBtn = this.querySelector('[data-appointment-booking-exam-info-change]')
    this.bookingConfirmationDateEl = this.querySelector('[data-appointment-booking-step-confirmation-date]')
    this.bookingConfirmationLocationEl = this.querySelector('[data-appointment-booking-step-confirmation-location]')
    this.reloadBtn = this.querySelector('[data-appointment-booking-reload]')
    this.childAgeRangeText = this.querySelector('#child-age-range')
    this.adultAgeRangeText = this.querySelector('#adult-age-range')

    // Data
    this.clinicID = null
    this.stepperData = {
      'exam-type': null,
      'exam-age': null,
      'exam-patient': null
    }
    this.appointmentBody = {
      'firstName': null,
      'lastName': null,
      'email': null,
      'phone': null,
      'diaryId': null,
      'appointmentMotivationID': null,
      'appointmentMotivation': null,
      'appointmentStatus': null,
      'appointmentType': null, // Adult, senior, child
      'appointmentDatetime': null,
      'appointmentDuration': null,
      'appointmentNotes': null,
      'newPatient': null,
      'optionIDs': null,
      'source': null
    }
    this.userBody = {
      "firstName": null,
      "lastName": null,
      "dateOfBirth": null,
      "email": null,
      "phone": null,

    }
    this.dependantBody = {
      "firstName": null,
      "lastName": null,
      "dateOfBirth": null,
    }

    this.clinicRange = 100
    this.isCustomer = this.hasAttribute('data-appointment-booking-is-customer')

    this.initAppointmentBookingSteps()
  }

  /**
   * Initializes stepper and handles main event listeners
   */
  async initAppointmentBookingSteps() {
    this.stepEls.forEach((stepEl) => {
      this.stepOptionListener(stepEl)
    })

    this.backBtn.addEventListener('click', () => {
      const currentStep = parseInt(this.dataset.appointmentBookingActiveStep, 10)

      this.changeStep(currentStep - 1)

      if (currentStep !== 5) {
        this.continueBtn.classList.remove('active')
      }
    })

    this.continueBtn.addEventListener('click', () => {
      this.continueToForm()
    })

    this.clinicEditBtn.addEventListener('click', () => {
      this.clinicsPopupToggle(true)
    })

    this.clinicsPopup.addEventListener('click', (event) => {
      this.clinicsPopupListener(event)
    })

    this.clinicsPopupClose.addEventListener('click', () => {
      this.clinicsPopupToggle(false)
    })

    this.clinicsPopupOverlay.addEventListener('click', () => {
      this.clinicsPopupToggle(false)
    })

    this.optometristEditBtn.addEventListener('click', () => {
      this.optometristsPopupToggle(true)
    })

    this.optometristsPopupClose.addEventListener('click', () => {
      this.optometristsPopupToggle(false)
    })

    this.optometristsPopupOverlay.addEventListener('click', () => {
      this.optometristsPopupToggle(false)
    })

    this.optometristChangeBtn.addEventListener('click', () => {
      this.changeOptometrist()
    })

    this.datesSwiperContainer.addEventListener('click', (event) => {
      if (!event.target.hasAttribute('data-appointment-booking-date')) {
        return
      }

      this.dateSelected(event.target)
    })

    this.timesGrid.addEventListener('click', (event) => {
      if (!event.target.hasAttribute('data-appointment-booking-time')) {
        return
      }

      this.timeSelected(event.target)
    })

    this.patientAdultForm.addEventListener('submit', (event) => {
      this.patientFormSubmit(event)
    })

    this.patientChildForm.addEventListener('submit', (event) => {
      this.patientFormSubmit(event)
    })

    this.examInfoChangeBtn.addEventListener('click', () => {
      this.changeStep(4)
    })

    this.reloadBtn.addEventListener('click', () => {
      location.reload()
    })

    this.setMaxHeight()
    this.getClinicData()
  }

  /**
   * Handles step option events, sets stepper data
   * @param {HTMLElement} stepEl : step option element
   */
  stepOptionListener(stepEl) {
    const stepNumber = parseInt(stepEl.dataset.appointmentBookingStep, 10)
    const stepOptions = stepEl.querySelectorAll('[data-appointment-booking-step-option]')

    stepOptions.forEach((stepOption) => {
      stepOption.addEventListener('click', (event) => {
        if (event.clientX === 0 && event.clientY === 0) {
          return
        }

        this.stepperData[stepOption.name] = stepOption.value
        this.changeStep(stepNumber + 1)
      })

      stepOption.addEventListener('keydown', (event) => {
        if ((event.key === 'Tab' || event.key === 'Enter') && stepOption.checked) {
          this.stepperData[stepOption.name] = stepOption.value
          this.changeStep(stepNumber + 1)
        }
      })
    })
  }

  /**
   * Changes stepper step, if on step 4 calls dateAndTimeSetup()
   * @param {Number} stepNumber : step to change to
   */
  changeStep(stepNumber) {
    if (stepNumber === 4 && !this.continueBtn.classList.contains('active')) {
      this.dateAndTimeSetup()
    } else {
      this.setAttribute('data-appointment-booking-active-step', stepNumber)
    }

    if (stepNumber === 5) {
      if (this.stepperData['exam-age'] === 'child') {
        this.patientChildFormNameFirst.focus()
      } else {
        this.patientAdultFormNameFirst.focus()
      }
    }

    if (stepNumber === 6) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }

    if (stepNumber !== 'loading' && stepNumber !== 'error') {
      const searchParams = new URLSearchParams(window.location.search)
      const newUrlWithStepHash = `${window.location.pathname}?${searchParams.toString()}#step-${stepNumber}`

      history.replaceState(null, '', newUrlWithStepHash)
    }
  }

  /**
   * Dynamically sets section height based on header height
   * @returns if no header found
   */
  setMaxHeight() {
    const header = document.querySelector('#shopify-section-header')

    if (!header) { return }

    this.style.height = `calc(100svh - ${header.offsetHeight}px)`
  }

  /**
   * Displays error message to user
   */
  throwError() {
    this.setAttribute('data-appointment-booking-active-step', 'error')
  }

  /**
   * Gets clinic ID from query param, calls api methods, loads first step
   */
  async getClinicData() {
    if (this.clinicID === null) {
      const urlParams = new URLSearchParams(window.location.search)
      const idFromUrl = urlParams.get('locationId')

      if (idFromUrl !== null) {
        this.clinicID = parseInt(idFromUrl, 10)
      } else if (!this.classList.contains('in-admin')) {
        window.location.href = '/pages/find-a-location'
      }
    }

    await this.getClinicInformation()
    await this.getClinicVisitTypes()
    await this.getClinicConfiguration()

    this.setupPreferredClinicCheckboxes()
    this.changeStep(1)
  }

  /**
   * Brings user to final form, formats appointment data
   */
  continueToForm() {
    this.appointmentBody['diaryId'] = this.selectedFreeTimeSlot.diaryId
    this.appointmentBody['appointmentMotivationID'] = this.visitType.visitTypeID
    this.appointmentBody['appointmentMotivation'] = this.visitType.name
    this.appointmentBody['appointmentStatus'] = ''
    this.appointmentBody['appointmentDatetime'] = this.selectedFreeTimeSlot.startTime
    this.appointmentBody['appointmentDuration'] = this.selectedFreeTimeSlot.bookingDuration
    this.appointmentBody['appointmentNotes'] = null
    this.appointmentBody['newPatient'] = this.stepperData['exam-patient'] === 'new' ? true : false
    this.appointmentBody['optionIDs'] = [this.wearsContactsPatientOptionID]

    // TODO: ^
    // this.appointmentBody['optionIDs']: 
    // Appears to just be the value from the last wearsCLs question in the /configuration payload. To be confirmed
    const examDate = new Date(this.selectedFreeTimeSlot.startTime)
    const examWeekday = examDate.toLocaleString('default', { weekday: 'long' })
    const examMonth = examDate.toLocaleString('default', { month: 'long' })
    const examEndTime = new Date(examDate.getTime() + this.selectedFreeTimeSlot.bookingDuration * 60000)
    const ageValidationDate = new Date(examDate);
    ageValidationDate.setFullYear(ageValidationDate.getFullYear() - 18);
    const isAdulthoodNineteen = this.patientFormStepEl.dataset.isAdulthoodNineteen

    this.examInfoDetailsEl.innerHTML = `${this.selectedDoctor}<br>${examWeekday}, ${examMonth}&nbsp;${this.formatDateWithSuffix(examDate.getDate())}`
    this.examInfoTimeEl.innerHTML = `${examDate.toLocaleTimeString('default', { hour12: true, hour: 'numeric', minute: 'numeric' })} - ${examEndTime.toLocaleTimeString('default', { hour12: true, hour: 'numeric', minute: 'numeric' })}`

    if (this.bookingConfirmationDateEl) {
      this.bookingConfirmationDateEl.innerHTML = `${examWeekday} at <span class="lowercase">${examDate.toLocaleTimeString('default', { hour12: true, hour: 'numeric', minute: 'numeric' })}</span>`
    }
    if (isAdulthoodNineteen === 'true') {
      if (this.patientAdultFormDob) {
        // max: exactly 19 years ago (inclusive — someone turning 19 on the exam date qualifies)
        const max = new Date(examDate.getFullYear() - 19, examDate.getMonth(), examDate.getDate());
        this.patientAdultFormDob.setAttribute('max', max.toISOString().split('T')[0])
      }

      if (this.patientChildFormDob) {
        // min: 19 years ago + 1 day (exclusive — someone who is already 19 does NOT qualify)
        const min = new Date(examDate.getFullYear() - 19, examDate.getMonth(), examDate.getDate() + 1);
        this.patientChildFormDob.setAttribute('min', min.toISOString().split('T')[0])
      }
    } else {
      this.patientAdultFormDob.setAttribute('max', ageValidationDate.toISOString().split('T')[0])
      
      // Add one day for child booking, as we don't want to include a person turning 18 y.o. on the exam date for child booking
      ageValidationDate.setDate(ageValidationDate.getDate() + 1);
      this.patientChildFormDob.setAttribute('min', ageValidationDate.toISOString().split('T')[0])
    }

    // Min child age for online appt booking is 4 y.o., no matter the province
    if (this.patientChildFormDob) {
      const fourYearsAgo = new Date(examDate);
      fourYearsAgo.setFullYear(fourYearsAgo.getFullYear() - 4);
      this.patientChildFormDob.setAttribute('max', fourYearsAgo.toISOString().split('T')[0])
    }

    this.patientFormStepEl.classList.toggle('is-child', this.stepperData['exam-age'] === 'child')
    this.examInfoContainer.classList.toggle('is-contacts', this.stepperData['exam-type'] === 'glasses-and-contacts')

    this.changeStep(5)
  }

  /**
   * Handles appointment form submission, verifies child dob
   * @param {Event} event 
   * @returns if child age is not valid
   */
  async patientFormSubmit(event) {
    event.preventDefault()

    const dobField = this.stepperData['exam-age'] === 'child' ? this.patientChildFormDob : this.patientAdultFormDob
    const errorField = this.stepperData['exam-age'] === 'child' ? this.patientChildFormDobError : this.patientAdultFormDobError
    const patientDob = new Date(dobField.value)
    let dobError = false

    if (this.stepperData['exam-age'] === 'child') {
      const patientDobMin = new Date(dobField.getAttribute('min'))
      dobError = patientDob < patientDobMin
    } else {
      const patientDobMax = new Date(dobField.getAttribute('max'))
      dobError = patientDob > patientDobMax
    }
    errorField.classList.toggle('hide', !dobError)

    // Check if phone number is too short
    const phoneField = this.stepperData['exam-age'] === 'child' ? this.patientChildFormPhone : this.patientAdultFormPhone
    this.patientFormPhoneError.classList.toggle('hide', phoneField.value.length >= 10)
    if (dobError || phoneField.value.length < 10) {
      return
    }

    await this.createBooking()
  }

  async createBooking() {
    if (this.stepperData['exam-age'] === 'child') {
      this.patientChildFormSubmit.disabled = true
    } else {
      this.patientAdultFormSubmit.disabled = true
    }

    const firstName = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormNameFirst.value
      : this.patientAdultFormNameFirst.value
    const lastName = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormNameLast.value
      : this.patientAdultFormNameLast.value
    const name = `${firstName} ${lastName}`.trim()
    const email = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormEmail.value
      : this.patientAdultFormEmail.value
    const phone = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormPhone.value
      : this.patientAdultFormPhone.value
    const note = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormNotes.value
      : this.patientAdultFormNotes.value
    const dob = this.stepperData['exam-age'] === 'child'
      ? this.patientChildFormDob.value
      : this.patientAdultFormDob.value

    // TODO: verify insurance info values (provincialHealthNumber, insurancePlanNumber, insuranceProvider)
    const provincialHealthNumber = this.insuranceFormProvincialHealthNumber.value
    const insurancePlanNumber = this.insuranceFormPolicy.value
    const insuranceProvider = this.insuranceFormProviderName.value

    let parentData = ''

    if (this.stepperData['exam-age'] === 'child') {
      parentData = ` Parent: ${this.patientChildFormParentNameFirst.value} ${this.patientChildFormParentNameLast.value}`
    }

    const shortAppointmentNotes = `PH:${phone} DOB:${dob} PHN:${provincialHealthNumber} Ins#:${insurancePlanNumber} Provider:${insuranceProvider}${parentData} Notes: ${note}`
    let accountName = this.isCustomer
      ? this.patientFormStepEl.dataset.appointmentBookingCustomerName
      : name

    if (this.stepperData['exam-age'] === 'child') {
      // Use parent/guardian's name if patient is child - see https://fyidoctors.atlassian.net/browse/PIP-1364
      accountName = `${this.patientChildFormParentNameFirst.value} ${this.patientChildFormParentNameLast.value}`.trim()
    }

    const differentPatientNote = accountName !== name ? `This appointment was booked by ${accountName} for ${name}\n` : ''
    const allPatientNotes = `${differentPatientNote}${shortAppointmentNotes}`
    const appointmentNotes = allPatientNotes.substring(0, 200)

    this.appointmentBody['appointmentNotes'] = appointmentNotes
    this.appointmentBody['firstName'] = firstName.trim()
    this.appointmentBody['lastName'] = lastName.trim()
    this.appointmentBody['email'] = email.trim()
    this.appointmentBody['phone'] = phone.trim()
    this.appointmentBody['source'] = window.location.hostname
    this.appointmentBody['appointmentType'] = this.stepperData['exam-age']

    // User object
    this.userBody['firstName'] = this.stepperData['exam-age'] === 'child' ? this.patientChildFormParentNameFirst.value.trim() : firstName.trim()
    this.userBody['lastName'] = this.stepperData['exam-age'] === 'child' ? this.patientChildFormParentNameLast.value.trim() : lastName.trim()
    this.userBody['email'] = email.trim()
    this.userBody['phone'] = phone.trim()
    this.userBody['dateOfBirth'] = this.stepperData['exam-age'] === 'child' ? null : this.patientAdultFormDob.value

    // Dependant object - in case of child booking
    if (this.stepperData['exam-age'] === 'child') {
      this.dependantBody['firstName'] = firstName.trim()
      this.dependantBody['lastName'] = lastName.trim()
      this.dependantBody['dateOfBirth'] = this.patientChildFormDob.value
      delete this.userBody['dateOfBirth']
    }

    const token = localStorage.getItem('LRTokenKey')
    const apiUrl = (!this.isCustomer || !token)
      ? `${window.apiUrl}/guest/appointments`
      : `${window.apiUrl}/appointments`
    const apiHeaders = (!this.isCustomer || !token)
      ? {
        'Content-Type': 'application/json; charset=utf-8'
      }
      : {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      }

    const utmSource = window.sessionStorage.getItem('utm_source')

    const appointmentPostBody = {
      appointment: this.appointmentBody,
      user: this.userBody,
      ...(utmSource ? { utmSource } : {}),
    }

    if (this.stepperData['exam-age'] === 'child') {
      appointmentPostBody.dependant = this.dependantBody
    }

    const fetchOptions = {
      method: 'POST',
      headers: apiHeaders,
      body: JSON.stringify(appointmentPostBody)
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(result => {
        console.log(result)

        if (this.stepperData['exam-age'] === 'child') {
          this.patientChildFormSubmit.disabled = false
        } else {
          this.patientAdultFormSubmit.disabled = false
        }

        this.changeStep(6)
        window.sessionStorage.removeItem('utm_source')
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
        this.throwError()
      })
  }

  /**
   * Reset appointment booking with new clinic
   * @param {Number} newClinicID : clinic ID to change to
   */
  resetBooking(newClinicID) {
    this.clinicID = newClinicID

    this.setAttribute('data-appointment-booking-active-step', 'loading')
    this.continueBtn.classList.remove('active')
    this.clinicsPopupLocationsSearchInput.value = ''
    this.clinicsPopup.setAttribute('data-appointment-booking-clinics-popup-initialized', false)

    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('locationId', `${newClinicID}`)

    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString()
    history.replaceState(null, '', newRelativePathQuery)

    this.clinicsPopupToggle(false)
    this.getClinicData()
  }

  /**
   * Setup preferred clinic checkbox on final details step
   */
  setupPreferredClinicCheckboxes() {
    if (localStorage.getItem('preferred_clinic')) {
      const preferredClinicID = localStorage.getItem('preferred_clinic')

      this.isPreferredClinicCheckboxes.forEach((isPreferredClinicCheckbox) => {
        isPreferredClinicCheckbox.checked = (preferredClinicID === `${this.clinicID}`)
      })
    } else if (localStorage.getItem('preferred_clinic_information')) {
      const preferredClinicInfo = JSON.parse(localStorage.getItem('preferred_clinic_information'))

      this.isPreferredClinicCheckboxes.forEach((isPreferredClinicCheckbox) => {
        isPreferredClinicCheckbox.checked = (preferredClinicInfo.id === `${this.clinicID}`)
      })
    }

    this.isPreferredClinicCheckboxes.forEach((isPreferredClinicCheckbox) => {
      isPreferredClinicCheckbox.addEventListener('change', () => {
        if (isPreferredClinicCheckbox.checked) {
          localStorage.setItem('preferred_clinic', `${this.clinicID}`)
        }
      })
    })
  }

  /**
   * Handles clinic change button click
   * @param {Event} event : click event on popup
   */
  clinicsPopupListener(event) {
    if (event.target.hasAttribute('data-appointment-booking-change-clinic')) {
      const newClinicID = parseInt(event.target.dataset.appointmentBookingChangeClinic, 10)

      if (newClinicID === this.clinicID) {
        this.clinicsPopupToggle(false)
      } else {
        this.resetBooking(newClinicID)
      }
    }
  }

  /**
   * Handles clinic change popup
   * @param {Boolean} open : open or close popup
   */
  clinicsPopupToggle(open) {
    this.clinicsPopup.classList.toggle('active', open)

    if (open && this.clinicsPopup.dataset.appointmentBookingClinicsPopupInitialized === 'false') {
      this.clinicsPopup.classList.add('loading')
      this.clinicsPopup.setAttribute('data-appointment-booking-clinics-popup-initialized', true)
      this.initClinicsPopup()
      this.initLocationsSearch()
    }

    if (open) {
      document.body.style.overflow = 'hidden'
      this.clinicsPopup.setAttribute('aria-hidden', false)
      this.clinicEditBtn.setAttribute('aria-expanded', true)
      this.clinicsPopup.focus()
      trapFocus(this.clinicsPopup)
      this.clinicsPopup.focus()
    } else {
      document.body.style.overflow = 'auto'
      this.clinicsPopup.setAttribute('aria-hidden', true)
      this.clinicEditBtn.setAttribute('aria-expanded', false)
      removeTrapFocus()
      this.clinicEditBtn.focus()
    }
  }

  /**
   * Handles optometrist change popup
   * @param {Boolean} open : open or close popup
   */
  optometristsPopupToggle(open) {
    this.optometristsPopup.classList.toggle('active', open)

    if (open) {
      document.body.style.overflow = 'hidden'
      this.optometristsPopup.setAttribute('aria-hidden', false)
      this.optometristEditBtn.setAttribute('aria-expanded', true)
      this.optometristsPopup.focus()
      trapFocus(this.optometristsPopup)
      this.optometristsPopup.focus()
    } else {
      document.body.style.overflow = 'auto'
      this.optometristsPopup.setAttribute('aria-hidden', true)
      this.optometristEditBtn.setAttribute('aria-expanded', false)
      removeTrapFocus()
      this.optometristEditBtn.focus()
    }
  }

  /**
   * Changes optometrist and resets applicable data for date/time step
   */
  async changeOptometrist() {
    this.optometristsPopupToggle(false)

    this.setAttribute('data-appointment-booking-active-step', 'loading')

    const optometristSelect = this.querySelector('[data-appointment-booking-optometrist-select]')
    const optometristName = optometristSelect.options[optometristSelect.selectedIndex].text
    const diaryID = optometristSelect.value

    this.timesGrid.innerHTML = ''
    this.continueBtn.classList.remove('active')

    this.optometristNameEl.innerHTML = optometristName

    await this.getClinicSlots(diaryID)

    this.setAttribute('data-appointment-booking-active-step', 4)
  }

  /**
   * Setup for date/time step
   */
  async dateAndTimeSetup() {
    this.setAttribute('data-appointment-booking-active-step', 'loading')

    this.timesGrid.innerHTML = ''

    await this.getClinicDiaries()
    await this.getClinicSlots(1)

    this.setOptometristsList()

    this.setAttribute('data-appointment-booking-active-step', 4)
  }

  /**
   * Sets practicingDoctors array, clinic display info
   * @param {Array} clinicData : data from getClinicInformation api fetch
   */
  setClinicInformation(clinicData) {
    this.practicingDoctors = clinicData.practicingDoctors
    this.clinicNameEl.innerHTML = clinicData.name
    this.examInfoClinicEl.innerHTML = clinicData.name

    if (this.bookingConfirmationLocationEl) {
      this.bookingConfirmationLocationEl.innerHTML = clinicData.name
    }

    if (this.locationTitleEl) {
      this.locationTitleEl.innerHTML = clinicData.name
    }

    // Provinces where patients < 19 y.o. are considered minors. For all other provinces not listed here, patients < 18 are considered minors (see PIP-1820)
    const nineteenYearsProvinces = ['british columbia', 'new brunswick', 'newfoundland and labrador', 'nova scotia', 'nunavut', 'yukon']
    const isAdulthoodNineteen = nineteenYearsProvinces.includes(clinicData.address.province.toLowerCase())
    this.patientFormStepEl.dataset.isAdulthoodNineteen = isAdulthoodNineteen
    if (this.childAgeRangeText && this.adultAgeRangeText) {
      if (isAdulthoodNineteen) {
        // Update step 2 for age group selection
          this.childAgeRangeText.innerHTML = this.childAgeRangeText.innerHTML.replace('17', '18')
          this.adultAgeRangeText.innerHTML = this.adultAgeRangeText.innerHTML.replace('18', '19')
      } else {
          // Revert back if user switches clinic
          this.childAgeRangeText.innerHTML = this.childAgeRangeText.innerHTML.replace('18', '17')
          this.adultAgeRangeText.innerHTML = this.adultAgeRangeText.innerHTML.replace('19', '18')
      }
    }
  }

  /**
   * Re-renders optometrists list in optometrists popup
   */
  setOptometristsList() {
    let optometristOptions = ''

    for (let i = 0; i < this.clinicDiaries.length; i++) {
      optometristOptions += `
        <option value="${this.clinicDiaries[i].diaryID}"
          data-appointment-booking-optometrist-select-option>
          ${this.clinicDiaries[i].doctorName.includes('Dr.') ? '' : 'Dr. '}${this.clinicDiaries[i].doctorName}
        </option>
      `
    }

    this.optometristSelectContainer.innerHTML = `
      <dropdown-select data-appointment-booking-optometrist-select-container>
        <select id="optometrist-select"
          name="clinic-optometrist"
          aria-label="${window.appointmentBookingStrings.appointmentWith}"
          data-appointment-booking-optometrist-select>
          <option value="1" 
            selected
            data-appointment-booking-optometrist-select-default>
            ${window.appointmentBookingStrings.anyOptometrist}
          </option>
          ${optometristOptions}
        </select>
      </dropdown-select>
    `

    this.optometristNameEl.innerHTML = `${window.appointmentBookingStrings.anyOptometrist}`
  }

  /**
   * Sets up available options for first 3 steps
   * @param {Array} visitTypes : data from getClinicVisitTypes api fetch
   */
  setAvailableExamTypes(visitTypes) {
    this.availableVisitTypes = visitTypes

    const glassesVisitTypes = visitTypes.filter((visitType) => visitType.name.includes('Eye'))
    const contactsVisitTypes = visitTypes.filter((visitType) => visitType.name.includes('CL'))
    const childVisitTypes = visitTypes.filter((visitType) => visitType.name.includes('Child'))

    this.optionExamTypeGlasses.toggleAttribute('disabled', glassesVisitTypes.length === 0)
    this.optionExamTypeGlassesAndContacts.toggleAttribute('disabled', contactsVisitTypes.length === 0)
    this.optionExamAgeChild.toggleAttribute('disabled', childVisitTypes.length === 0)
  }

  /**
   * Handles date selected event, passes available time slots to buildTimesGrid
   * @param {HTMLElement} dateEl : date element
   */
  dateSelected(dateEl) {
    const dateEls = this.datesSwiperWrapper.querySelectorAll('[data-appointment-booking-date]')

    dateEls.forEach((el) => { el.classList.remove('active') })

    dateEl.classList.add('active')

    this.continueBtn.classList.remove('active')

    const selectedFreeSlot = this.freeSlots.find((freeSlot) =>
      freeSlot.date === dateEl.dataset.appointmentBookingDate
    )

    const freeTimeSlots = selectedFreeSlot.timePeriods[0].freeSlots

    this.buildTimesGrid(freeTimeSlots)
  }

  /**
   * Handles time selected evemt, enables continue button
   * @param {HTMLElement} timeEl : time element
   */
  timeSelected(timeEl) {
    const timeEls = this.timesGrid.querySelectorAll('[data-appointment-booking-time]')

    timeEls.forEach((el) => { el.classList.remove('active') })

    timeEl.classList.add('active')

    const selectedFreeTimeSlot = this.freeTimeSlots.find((freeTimeSlot) =>
      freeTimeSlot.doctorId === timeEl.dataset.appointmentBookingDoctorId && freeTimeSlot.startTime === timeEl.dataset.appointmentBookingTime
    )

    this.selectedFreeTimeSlot = selectedFreeTimeSlot
    this.selectedDoctor = timeEl.dataset.appointmentBookingDoctor

    this.continueBtn.classList.add('active')
    this.continueBtn.focus()
  }

  /**
   * Renders free time slots as buttons in a grid
   * @param {Array} freeTimeSlots : array of free time slots
   */
  buildTimesGrid(freeTimeSlots) {
    this.freeTimeSlots = freeTimeSlots

    let timeElements = ''

    for (let i = 0; i < freeTimeSlots.length; i++) {
      const slotDate = new Date(freeTimeSlots[i].startTime)
      const practicingDoctor = this.clinicDiaries.find((doctor) =>
        doctor.doctorID === parseInt(freeTimeSlots[i].doctorId, 10)
      )

      timeElements += `
        <button class="appointment-booking-steps__time"
          type="button"
          data-appointment-booking-time="${freeTimeSlots[i].startTime}"
          data-appointment-booking-doctor="${practicingDoctor.doctorName.includes('Dr') ? '' : 'Dr. '}${practicingDoctor.doctorName}"
          data-appointment-booking-doctor-id="${practicingDoctor.doctorID}">
          <span>${slotDate.toLocaleTimeString('default', { hour12: true, hour: 'numeric', minute: 'numeric' })}</span>
          <span>${practicingDoctor.doctorName.includes('Dr') ? '' : 'Dr. '}${practicingDoctor.doctorName}</span>
        </button>
      `
    }

    this.timesGrid.innerHTML = timeElements

    const firstTimeElement = this.timesGrid.querySelector('[data-appointment-booking-time]')

    if (firstTimeElement) {
      firstTimeElement.focus()
    }
  }

  /**
   * Renders free date slots as buttons in a slider
   * @param {Array} freeSlots 
   * @returns slider element (swiper)
   */
  buildDatesSwiper(freeSlots) {
    this.freeSlots = freeSlots

    this.noSlotsEl.classList.toggle('active', freeSlots.length < 1)

    let dateElements = ''

    for (let i = 0; i < freeSlots.length; i++) {
      const slotDate = new Date(freeSlots[i].date)

      dateElements += `
        <button class="appointment-booking-steps__date swiper-slide"
          type="button"
          data-appointment-booking-date="${freeSlots[i].date}">
          <span>${slotDate.toLocaleString('default', { weekday: 'long' })}</span>
          <span>${slotDate.toLocaleString('default', { month: 'short' })}&nbsp;${this.formatDateWithSuffix(slotDate.getDate())}</span>
        </button>
      `
    }

    this.datesSwiperWrapper.innerHTML = dateElements

    if (this.swiper) {
      this.swiper.destroy()
    }

    this.swiper = new Swiper(this.datesSwiperContainer, {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 8,
      threshold: 10,
      freeMode: true,
      noSwiping: false,
      draggable: true,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints: {
        750: {
          spaceBetween: 20
        }
      },
      navigation: {
        nextEl: '[data-appointment-booking-dates-swiper-next]',
        prevEl: '[data-appointment-booking-dates-swiper-prev]',
        disabledClass: 'disabled'
      }
    })

    return this.swiper
  }

  /**
   * Sets search location object
   * @param {Object} place : object returned from Google Maps autocomplete
   */
  setSearchLocation(place) {
    try {
      const placeLocation = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
      this.searchLocation = placeLocation
    } catch (error) {
      console.error(error)
      this.searchLocation = null
    }
  }

  /**
   * Sets up new locations array with search location object
   */
  filterSearchLocations() {
    if (this.searchLocation !== null) {
      const filteredLocations = this.locations.filter(item => {
        return this.calcCrow(this.searchLocation.lat, this.searchLocation.lng, item.geometry.coordinates[1], item.geometry.coordinates[0]) <= this.clinicRange
      })

      const sortedFilteredLocations = filteredLocations.sort((a, b) => {
        const aDistance = this.calcCrow(this.searchLocation.lat, this.searchLocation.lng, a.geometry.coordinates[1], a.geometry.coordinates[0])
        const bDistance = this.calcCrow(this.searchLocation.lat, this.searchLocation.lng, b.geometry.coordinates[1], b.geometry.coordinates[0])
        return aDistance - bDistance
      })

      this.renderLocationsList(sortedFilteredLocations, this.searchLocation)
    }
  }

  /**
   * Handles location input, setup with Google Maps autocomplete
   */
  initLocationsSearch() {
    const autocompleteInput = new google.maps.places.Autocomplete(this.clinicsPopupLocationsSearchInput)

    autocompleteInput.setComponentRestrictions({
      country: ['ca']
    })

    google.maps.event.addListener(autocompleteInput, 'place_changed', () => {
      this.setSearchLocation(autocompleteInput.getPlace())
    })

    this.clinicsPopupLocationsSearchButton.addEventListener('click', () => {
      this.filterSearchLocations()
    })
  }

  /**
   * Fetch clinics from location api to setup clinics popup
   */
  async initClinicsPopup() {
    await fetch(`${window.apiUrl}/locations`)
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Failed to fetch locations')
        }
      })
      .then(resultLocations => {
        const locations = resultLocations.features

        if (navigator.geolocation) {
          const positionAllowed = (position) => {
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }

            this.userLocation = userLocation

            const sortedLocations = locations.sort((a, b) => {
              const aDistance = this.calcCrow(userLocation.lat, userLocation.lng, a.geometry.coordinates[1], a.geometry.coordinates[0])
              const bDistance = this.calcCrow(userLocation.lat, userLocation.lng, b.geometry.coordinates[1], b.geometry.coordinates[0])
              return aDistance - bDistance
            })

            this.locations = sortedLocations
            this.initLocationsList()
          }

          const positionDenied = () => {
            this.locations = locations
            this.initLocationsList()
          }

          navigator.geolocation.getCurrentPosition(positionAllowed, positionDenied)
        } else {
          this.locations = locations
          this.initLocationsList()
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  /**
   * Filter clinic locations to pass to renderLocationsList
   */
  initLocationsList() {
    const filteredLocations = this.locations.filter(item => {
      return this.calcCrow(this.userLocation.lat, this.userLocation.lng, item.geometry.coordinates[1], item.geometry.coordinates[0]) <= this.clinicRange
    })

    this.renderLocationsList(filteredLocations, this.userLocation)
  }

  /**
   * Renders clinic locations in clinics popup
   * @param {Array} locations : array of filtered clinic locations
   * @param {Object} setLocation : user location
   */
  renderLocationsList(locations, setLocation) {
    let locationElements = ''
    this.clinicsPopupCountContainer.classList.toggle('appointment-booking-steps__locations-count--single', locations.length === 1)
    this.clinicsPopupCountEl.innerHTML = locations.length

    locations.forEach((location) => {
      const locationDistanceKm = this.calcCrow(setLocation.lat, setLocation.lng, location.geometry.coordinates[1], location.geometry.coordinates[0])
      const locationDistance = `${locationDistanceKm.toFixed(2)}km`

      locationElements += `
        <div class="appointment-booking-steps__location${(location.id === `${this.clinicID}`) ? ' appointment-booking-steps__location--preferred' : ''}">
          <p class="appointment-booking-steps__location-title">
            ${location.properties.location.name}
            <span>${locationDistance}</span>
          </p>
          ${(location.properties.location.phoneNumber !== null)
          ? `<a href="tel:${location.properties.location.phoneNumber}"
                class="appointment-booking-steps__location-tel">
                ${this.formatPhoneNumber(location.properties.location.phoneNumber)}
              </a>`
          : ''
        }
          <p class="appointment-booking-steps__location-address">
            ${(location.properties.location.address.addressLine1 !== null)
          ? `${location.properties.location.address.addressLine1}`
          : ''
        }
            ${(location.properties.location.address.town !== null)
          ? `, ${location.properties.location.address.town}`
          : ''
        }
            ${(location.properties.location.address.province !== null)
          ? `, ${location.properties.location.address.province}`
          : ''
        }
          </p>
          ${(location.id === `${this.clinicID}`)
          ? `<p class="appointment-booking-steps__location-preferred">
                <span></span>
                This is your selected clinic
              </p>`
          : ''
        }
          <button type="button"
            class="appointment-booking-steps__location-cta button"
            data-appointment-booking-change-clinic="${location.id}">
            Select location
            <span></span>
          </button>
        </div>
      `
    })

    this.clinicsPopupLocationsListEl.innerHTML = locationElements
    this.clinicsPopup.classList.remove('loading')
  }

  /**
   * Get clinic information from locations api
   * @returns false if required data is missing
   */
  async getClinicInformation() {
    if (this.clinicID === null) {
      return false
    }

    const apiUrl = `${window.apiUrl}/locations/${this.clinicID}`
    const fetchOptions = {
      method: 'GET'
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        this.setClinicInformation(data)
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
        this.throwError()
      })
  }

  /**
   * Gets visit type data from locations api
   * @returns false if required data is missing
   */
  async getClinicVisitTypes() {
    if (this.clinicID === null) {
      return false
    }

    const apiUrl = `${window.apiUrl}/locations/${this.clinicID}/visit-types`
    const fetchOptions = {
      method: 'GET'
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        this.setAvailableExamTypes(data.visitTypes)
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
      })
  }

  /**
   * Gets clinic configuration from configuration api
   * @returns false if required data is missing
   */
  async getClinicConfiguration() {
    if (this.clinicID === null) {
      return false
    }

    const apiUrl = `${window.apiUrl}/configuration/${this.clinicID}`
    const fetchOptions = {
      method: 'GET'
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        this.bookingHorizonPeriod = data.diaryPeriodLimits.bookingHorizonPeriod
        this.bookingQuestionHierarchy = data.bookingQuestionHierarchy
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
      })
  }

  /**
   * Gets clinic diaries from locations api
   * @returns false if required data is missing
   */
  async getClinicDiaries() {
    if (this.clinicID === null) {
      return false
    }

    const apiUrl = `${window.apiUrl}/locations/${this.clinicID}/diaries`
    const fetchOptions = {
      method: 'GET'
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        this.clinicDiaries = data.diaries.sort(function (a, b) {
          // eslint-disable-next-line one-var
          const keyA = a.doctorName,
            keyB = b.doctorName;
          if (keyA > keyB) return 1;
          if (keyA < keyB) return -1;
          return 0;
        })
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
        this.throwError()
      })
  }

  /**
   * Get available clinic slots from locations api
   * Api url is built based on stepper data / selected options
   * @param {String} diaryID : sets doctor clinic slots to include, set to 1 for all doctors
   * @returns false if required data is missing
   */
  async getClinicSlots(diaryID) {
    if (this.clinicID === null) {
      return false
    }

    const today = new Date()
    const toDateUnformmated = new Date()

    if (this.bookingHorizonPeriod.hours !== 0) {
      toDateUnformmated.setTime(toDateUnformmated.getTime() + this.bookingHorizonPeriod.hours * 3600000)
    }

    if (this.bookingHorizonPeriod.days !== 0) {
      toDateUnformmated.setDate(toDateUnformmated.getDate() + this.bookingHorizonPeriod.days)
    }

    if (this.bookingHorizonPeriod.weeks !== 0) {
      toDateUnformmated.setDate(toDateUnformmated.getDate() + this.bookingHorizonPeriod.weeks * 7)
    }

    let visitType = null

    if (this.stepperData['exam-age'] === 'child') {
      if (this.stepperData['exam-type'] === 'glasses-and-contacts') {
        visitType = this.availableVisitTypes.find((visitType) => visitType.name.includes('Childs CL'))
      } else if (this.stepperData['exam-type'] === 'glasses') {
        visitType = this.availableVisitTypes.find((visitType) => visitType.name.includes('Childs Eye'))
      }
    } else {
      if (this.stepperData['exam-type'] === 'glasses-and-contacts') {
        visitType = this.availableVisitTypes.find((visitType) => visitType.name.includes('Full CL'))
      } else if (this.stepperData['exam-type'] === 'glasses') {
        visitType = this.availableVisitTypes.find((visitType) => visitType.name.includes('Full Eye'))
      }
    }

    this.isNewPatientOption = null
    this.ageRangePatientOption = null
    this.wearsContactsPatientOption = null

    // Get all patient options
    this.getPatientOptions(this.bookingQuestionHierarchy.firstQuestion)

    const fromDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
    const toDate = `${toDateUnformmated.getFullYear()}-${toDateUnformmated.getMonth() + 1}-${toDateUnformmated.getDate()}`
    const visitTypeID = visitType.visitTypeID
    const isNewPatientOptionID = this.isNewPatientOption.optionID
    const ageRangePatientOptionID = this.ageRangePatientOption.optionID
    const wearsContactsPatientOptionID = this.wearsContactsPatientOption.optionID

    this.visitType = visitType
    this.wearsContactsPatientOptionID = this.wearsContactsPatientOption.optionID

    const apiUrl = `${window.apiUrl}/locations/${this.clinicID}/slots?FromDate=${fromDate}&ToDate=${toDate}&DiaryID=${diaryID}&VisitTypeID=${visitTypeID}&optionIDs=${isNewPatientOptionID}&optionIDs=${ageRangePatientOptionID}&optionIDs=${wearsContactsPatientOptionID}`
    const fetchOptions = {
      method: 'GET'
    }

    await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        this.buildDatesSwiper(data.freeSlots[0].freeSlots)
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
      })
  }

  /**
   * Recursive function to retrieve all patient options
   * @param {Object} question : question object
   * @param {Number} depth : question depth (0-2 -> all 3 questions)
   * @returns once recursive function is wrapped
   */
  getPatientOptions(question, depth = 0) {
    if (!question || depth > 2) return

    let option
    switch (question.questionText) {
      case 'isNewPatient':
        option = this.getIsNewPatientOption(question.options)
        break
      case 'ageRange':
        option = this.getAgeRangePatientOption(question.options)
        break
      case 'wearsCLs':
        option = this.getWearsContactsPatientOption(question.options)
        break
    }

    if (option) {
      if (question.questionText === 'isNewPatient') {
        this.isNewPatientOption = option
      } else if (question.questionText === 'ageRange') {
        this.ageRangePatientOption = option
      } else if (question.questionText === 'wearsCLs') {
        this.wearsContactsPatientOption = option
      }
    }

    const nextQuestion = question.options[0]?.nextQuestion

    if (nextQuestion) {
      this.getPatientOptions(nextQuestion, depth + 1)
    }
  }

  /**
   * Finds applicable isNewPatient option
   * @param {Array} options : array of isNewPatient options
   * @returns matching isNewPatient option
   */
  getIsNewPatientOption(options) {
    if (this.stepperData['exam-patient'] === 'new') {
      return options.find((option) =>
        option.abbreviation.includes('NEW')
      )
    } else if (this.stepperData['exam-patient'] === 'returning') {
      return options.find((option) =>
        option.abbreviation.includes('EXISTING')
      )
    }
  }

  /**
   * Finds applicable ageRange option
   * @param {Array} options : array of ageRange options
   * @returns matching ageRange option
   */
  getAgeRangePatientOption(options) {
    if (this.stepperData['exam-age'] === 'senior') {
      return options.find((option) =>
        option.abbreviation === 'SENIOR'
      )
    } else if (this.stepperData['exam-age'] === 'adult') {
      return options.find((option) =>
        option.abbreviation === 'ADULT'
      )
    } else if (this.stepperData['exam-age'] === 'child') {
      return options.find((option) =>
        option.abbreviation === 'CHILD'
      )
    }
  }

  /**
   * Finds applicable wearsContacts option
   * @param {Array} options : array of wearsContacts options
   * @returns matching wearsContacts option
   */
  getWearsContactsPatientOption(options) {
    if (this.stepperData['exam-type'] === 'glasses-and-contacts') {
      return options.find((option) =>
        option.abbreviation.includes('WEARS')
      )
    } else if (this.stepperData['exam-type'] === 'glasses') {
      return options.find((option) =>
        option.abbreviation.includes('NO')
      )
    }
  }

  /**
   * Format date with appropriate suffix (Example: 1st or 4th)
   * @param {Number} number 
   * @returns date with suffix
   */
  formatDateWithSuffix(number) {
    if (number > 3 && number < 21) return `${number}th`

    switch (number % 10) {
      case 1:
        return `${number}st`
      case 2:
        return `${number}nd`
      case 3:
        return `${number}rd`
      default:
        return `${number}th`
    }
  }

  /**
   * Formats phone number: '(123) 456-7890'
   * @param {String} phoneNumber
   * @returns formatted phone number
   */
  formatPhoneNumber(phoneNumber) {
    let formattedPhoneNumber = phoneNumber

    try {
      if (phoneNumber.includes('+1')) {
        formattedPhoneNumber = phoneNumber.replace('+1', '')
      } else if (phoneNumber.includes('+')) {
        formattedPhoneNumber = phoneNumber.replace('+', '')
      }

      if (formattedPhoneNumber.length === 10) {
        formattedPhoneNumber = formattedPhoneNumber.replace(/^(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
      }
    } catch (error) {
      console.error(error)
      return phoneNumber
    }

    return formattedPhoneNumber.trim()
  }

  /**
   * Calculation to help with coordinates distance
   * @param {Int} value : value for calculation
   * @returns calculated value
   */
  toRad(value) {
    return value * Math.PI / 180
  }

  /**
   * Calculate coordinates distance
   * @param {Int} lat1 : 1st latitude value for calculation
   * @param {Int} lon1 : 1st longitude value for calculation
   * @param {Int} lat2 : 2nd latitude value for calculation
   * @param {Int} lon2 : 2nd longitude value for calculation
   * @returns calculated distance value
   */
  calcCrow(lat1, lon1, lat2, lon2) {
    var R = 6371 // km
    var dLat = this.toRad(lat2 - lat1)
    var dLon = this.toRad(lon2 - lon1)
    var lat1 = this.toRad(lat1)
    var lat2 = this.toRad(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c

    return d
  }
}

customElements.define('appointment-booking-steps', AppointmentBookingSteps)